module.exports = __webpack_public_path__ + "static/media/my.36735200.svg";